import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedComponent } from './components/shared/shared.component';
import { SharedRoutingModule } from './shared-routing.module';
import { HeaderComponent } from './components/header/header.component';
import { MenuItemComponent } from './components/sidebar/menu-item/menu-item.component';
import { FooterComponent } from './components/footer/footer.component';
import { SubSidebarComponent } from './components/sidebar/sidebar/sub-sidebar.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonViewComponent } from './components/common-view/common-view.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ViewDetailsLoaderComponent } from './components/content-loader/view-details-loader/view-details-loader.component';
import { ContentLoaderModule } from '@ngneat/content-loader';
import { TitleCaseWithoutUnderscorePipe } from './pipes/title-case-without-underscore-pipe.pipe';
import { ConfirmDownloadComponent } from './components/confirm-download/confirm-download.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PayAmountComponent } from './components/pay-amount/pay-amount.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatButtonModule } from '@angular/material/button';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { AccessDeniedPageComponent } from './components/access-denied-page/access-denied-page.component';
import { PartialCreditNoteComponent } from './components/credit-note/partial-credit-note/partial-credit-note.component';
import { ClientDropdownComponent } from './components/client-dropdown-filter/client-dropdown.component';
import { FilterComponent } from './components/filter-component/filter-component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { TruncatePipe } from './pipes/truncate-pipe';
import { InvoiceRetryModalComponent } from './components/invoice-retry-modal/invoice-retry-modal.component';
import { ConfirmCreditNoteComponent } from './components/confirm-credit-note/confirm-credit-note.component';
import { ConfirmInvoceEditComponent } from './components/confirm-invoce-edit/confirm-invoce-edit.component';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  OWL_DATE_TIME_FORMATS,
  OWL_DATE_TIME_LOCALE,
} from '@danielmoncada/angular-datetime-picker';
import { MY_NATIVE_FORMATS } from './config/date-time-config';
import { SalesOrderConfirmationComponent } from './components/sales-order-confirmation/sales-order-confirmation.component';
import { WorkOrderSummaryFilterComponent } from './components/work-order-summary-filter/work-order-summary-filter.component';
import { ViewModalComponent } from './components/view-modal/view-modal.component';
import { DistributionComponent } from './components/distribution/distribution.component';
import { MatRadioModule } from '@angular/material/radio';
import { CommonPartialCreditNoteComponent } from './components/common-partial-credit-note/common-partial-credit-note.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    SharedComponent,
    HeaderComponent,
    MenuItemComponent,
    SubSidebarComponent,
    FooterComponent,
    ConfirmationDialogComponent,
    CommonViewComponent,
    ViewDetailsLoaderComponent,
    TitleCaseWithoutUnderscorePipe,
    ConfirmDownloadComponent,
    PayAmountComponent,
    PageNotFoundComponent,
    AccessDeniedPageComponent,
    PartialCreditNoteComponent,
    ClientDropdownComponent,
    FilterComponent,
    LandingPageComponent,
    TruncatePipe,
    InvoiceRetryModalComponent,
    ConfirmCreditNoteComponent,
    ConfirmInvoceEditComponent,
    SalesOrderConfirmationComponent,
    WorkOrderSummaryFilterComponent,
    ViewModalComponent,
    DistributionComponent,
    CommonPartialCreditNoteComponent,
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    ContentLoaderModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatButtonModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxMaterialTimepickerModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatSlideToggleModule,
  ],
  exports: [
    SharedComponent,
    HeaderComponent,
    MenuItemComponent,
    SubSidebarComponent,
    FooterComponent,
    ConfirmationDialogComponent,
    CommonViewComponent,
    ViewDetailsLoaderComponent,
    TitleCaseWithoutUnderscorePipe,
    ClientDropdownComponent,
    FilterComponent,
    TruncatePipe,
    DistributionComponent,
    MatRadioModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatCardModule,
  ],
  providers: [
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_NATIVE_FORMATS },
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'en-IN' },
  ],
})
export class SharedModule {}
